import { render, staticRenderFns } from "./ModalAddBanking.vue?vue&type=template&id=cfb7aca8"
import script from "./ModalAddBanking.vue?vue&type=script&lang=js"
export * from "./ModalAddBanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports